import tw from 'tailwind-styled-components'


export const ActionButton = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
border
border-blueTheme
rounded-lg
w-[130px]
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`

export const UnitSectorTable = tw.table`
min-w-full divide-y divide-borderTable 
border-collapse
`

export const UnitSectorTHead = tw.thead`
sticky top-0 z-[1] bg-tableTitleBg h-[39px]

`
export const UnitSectorTr = tw.tr`
divide-x divide-gray-200 h-[39px] 
`
export const UnitSectorTh = tw.th`
px-4 text-sm font-semibold text-gray-900  text-left
`
export const UnitSectorTbody = tw.tbody`
divide-y divide-borderTable bg-white
`
export const UnitSectorTbodyTr = tw.tr`
divide-x relative
`
export const UnitSectorTbodyTd = tw.td`
text-textSelect 

`

export const trashComponent = `
absolute -right-7 top-1/2
transform translate-x-1/2
-translate-y-1/2
text-amberAlt
cursor-pointer
`
export const AddFields = tw.button`
mb-2
mt-4
w-[163px]
px-4
border 
rounded-lg 
py-2
border-amberAlt
text-amberAlt
font-medium
text-sm
flex
items-center
gap-2
hover:brightness-90
transition-all
`
export const NewUserContainer = tw.form`
py-6
px-8
`
export const SpanTop = tw.span`
text-xs
text-darkGray/70
flex
items-center
gap-2.5
mb-9
`

export const Ptitle = tw.p`
text-lg
font-bold
text-blueTheme
`





export const cancelButton = `
text-blueTheme
bg-white
`

export const saveButton = `
text-white
bg-blueTheme
`

export const locatedErrorSyle = `
text-errorText 
border-errorText 
outline-errorText50
`

export const Line = tw.div`
bg-darkGray/30
w-px
`

export const Div = tw.div``

export const Span = tw.span``

export const InputsContainer = tw.div`
flex 
flex-col 
gap-8 
mb-10
`

export const ContainerActionButtons = tw.div`
flex 
items-center 
gap-4
mb-32
`